import type { ReactNode } from 'react';
import { toExternalUrl } from '../../lib/utils';

interface ExternalLinkProps {
  href: string | null | undefined;
  className?: string;
  // По умолчанию подпись — сама ссылка как есть.
  children?: ReactNode;
}

// Внешняя ссылка из данных: в новой вкладке, опасные и битые — простым текстом.
export function ExternalLink({ href, className, children }: ExternalLinkProps) {
  const url = toExternalUrl(href);
  const label = children ?? href;
  if (!url) return <span className={className}>{label}</span>;
  return (
    <a href={url} target="_blank" rel="noreferrer" className={className}>
      {label}
    </a>
  );
}
